import React from "react";
import {Col, Input, Row} from "reactstrap";
import {ACCESSOIRES, nomAppareil} from "../../../../util/assistantPec";

/** Étape 3 : ce qui est déposé avec l'appareil, la panne décrite par le client et le code de déverrouillage. */
export default function EtapeAccessoires({ligne, onChange}) {
    const basculer = (accessoire) => {
        const coche = ligne.accessoires.includes(accessoire);
        onChange({accessoires: coche ? ligne.accessoires.filter(a => a !== accessoire) : [...ligne.accessoires, accessoire]});
    };
    const aucun = ligne.accessoires.length === 0 && !ligne.accessoiresAutre.trim();

    return (
        <div>
            <h4>Déposé avec {nomAppareil(ligne.appareil)}</h4>
            <div className="assistant-pec-tuiles">
                <button type="button" className={"assistant-pec-tuile assistant-pec-tuile-petite" + (aucun ? " choisie" : "")}
                        onClick={() => onChange({accessoires: [], accessoiresAutre: ""})}>
                    Rien d'autre
                </button>
                {ACCESSOIRES.map(a => (
                    <button type="button" key={a}
                            className={"assistant-pec-tuile assistant-pec-tuile-petite" + (ligne.accessoires.includes(a) ? " choisie" : "")}
                            onClick={() => basculer(a)}>
                        {ligne.accessoires.includes(a) && <i className="fa fa-check mr-2"/>}{a}
                    </button>
                ))}
            </div>
            <Input className="mt-2" placeholder="Autre chose (ex. : 2 palettes, sacoche…)" value={ligne.accessoiresAutre}
                   onChange={e => onChange({accessoiresAutre: e.target.value})}/>

            <Row className="mt-4">
                <Col md={8}>
                    <h4>Ce que dit le client</h4>
                    <Input type="textarea" rows={3} placeholder="Ex. : le joystick gauche dérive, ne charge plus…"
                           value={ligne.defauts} onChange={e => onChange({defauts: e.target.value})}/>
                </Col>
                <Col md={4}>
                    <h4>Code de déverrouillage</h4>
                    <Input placeholder="Mot de passe, code ou schéma" value={ligne.code}
                           onChange={e => onChange({code: e.target.value})}/>
                </Col>
            </Row>
        </div>
    );
}
